var isProdution = process.env.NODE_ENV === 'production'
module.exports = {
    // baseURL: isProdution?'':'http://120.24.204.173:8086'
    // baseURL: isProdution?'':'http://localhost:8093'
    baseURL: isProdution?'':''
}